import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'stay-mgmt-make-another-reservation',
  templateUrl: './make-another-reservation.component.html',
  styleUrls: ['./make-another-reservation.component.scss']
})
export class MakeAnotherReservationComponent implements OnInit {

  @Input() messages;
  @Output() makeAnotherReservationButtonClicked: EventEmitter<string>;

  constructor() {
    this.makeAnotherReservationButtonClicked = new EventEmitter();
   }

  ngOnInit() {
  }

  onButtonClick(): void {
    this.makeAnotherReservationButtonClicked.emit();
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/make-another-reservation/make-another-reservation.component.ts